import React, { useState } from 'react';
import { Button } from 'antd';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import { forgotPinPasswordLinkApi } from '../../services/authApi/forgotPinApi';
import { toastNotify } from '../../utils/toastNotify';
import './ForgotPIN.scss';

const RequestReset = () => {

  const [viewForm, setViewForm] = useState(false);
  const [countDown, setCountDown] = useState(0);
  const [isShowResend, setShowResend] = useState(false);


  const handleResendEmail = async(values) => {
    let formData = {
      email: localStorage.getItem("email"),
      phoneNumber: localStorage.getItem('phoneNumber'),
      credentialType: "pinAndPassword"
    }
    try {
      const userData = await forgotPinPasswordLinkApi(formData);
      if (!userData.isError) {
        toastNotify("success", userData.message);
        timerCounter();
      } else {
        toastNotify('error', userData?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  }

  const timerCounter = (timerValue = 30) => {
    setShowResend(true);
    let timeleft = timerValue;
    const downloadTimer = setInterval(() => {
      if(timeleft <= 0){
        clearInterval(downloadTimer);
        setCountDown(0);
        setShowResend(false);
      } else {
        if(timeleft < 10) {
          timeleft = 0 + '' + timeleft;
        }
        setCountDown(timeleft);
      }
      timeleft -= 1;
    }, 1000);
  }

  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm
        className={viewForm ? 'show' : null}
        title={<>Check your email</>}
        description={
          <>
            <p>
              Check your inbox to reset your pin. Click the link in the email we sent to <br />{' '}
              <span className='fw-600'>{localStorage.getItem("email")}</span>
            </p>
            <p>
                The link will expire in 10 minutes. Didn’t receive an email?{' '}
                <Button 
                  className='p-0 mr-8 fw-600 underline text-terracotta h-auto'
                  type='text' 
                  onClick={() => handleResendEmail()}
                  disabled={isShowResend}
                >
                  Resend email
                </Button>
                {countDown > 0 && <span>{countDown}</span> }
            </p>
          </>
        }
      >
      </AuthForm>
    </div>
  );
};

export default RequestReset;